module.exports = __webpack_public_path__ + "img/duels1.0ac1b8c7.webp";